let Vue = require('vue');

/**
 * Define global Vue components here.
 */
export default function defineGlobalComponents(vueContext) {
  // Popovers over interface texts possible to override
  vueContext.component(
    'EditInterfaceText',
    require('./modules/interface-text/components/EditInterfaceText.vue').default
  );
  vueContext.component(
    'Translation',
    require('./modules/interface-text/components/Translation.vue').default
  );

  // Every page can display feature intro coming from Holocron
  const FeatureIntro = require('./lib/components/Holocron/FeatureIntro.vue')
    .default;
  vueContext.component('FeatureIntro', FeatureIntro);
  Array.from(document.getElementsByClassName('feature-intro')).forEach(
    featureIntro => {
      new Vue({
        el: featureIntro,
        components: {
          'feature-intro': FeatureIntro
        }
      });
    }
  );
}
